import http from '@/utils/http';
const base_path = '/v2/tool/storyComponent';

/**
 * 获取Story转化组件列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getStoryComponentListApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};

/**
 * 创建Story转化组件接口
 * @param {Object} data 请求参数
 * @returns {Promise<Object>}
 */
export const addStoryComponentApi = (data) => {
  return http.post({
    url: base_path,
    data,
  });
};

/**
 * 查询Story创意组件可用按钮接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getStoryComponentButtonListApi = (params) => {
  return http.get({
    url: `${base_path}/button`,
    params,
  });
};
